import { customFetch, appendFormDataWithObjectValues } from 'utils/http';
import { HTTPResponseError } from 'utils/errors';
import { getM8AdminURL } from 'services/production/utils/getM8URL';

type Params = {
  type: string;
  endDate: string;
  amount: number;
};

export const addPriceToComponent = async (params: Params): Promise<void> => {
  const body = new FormData();

  appendFormDataWithObjectValues(body, params);

  const response = await customFetch(getM8AdminURL('addPriceToComponent'), {
    method: 'POST',
    body,
  });

  if (!response.ok) {
    throw new HTTPResponseError(response);
  }
};
